import { Entry } from "@noble-bits/cms/lib/types/content-models";
import TextModel from "@noble-bits/cms/lib/types/content-models/text-model";

const renderText = (entry: Entry<TextModel>): JSX.Element => {
    return <p className="nb-text--pre-wrap">{entry.fields.value}</p>
}

export default renderText;